import {
  ChangeEventHandler,
  forwardRef,
  InputHTMLAttributes,
  memo,
} from 'react'

import classnames from 'classnames'

export interface FileSelectProps extends InputHTMLAttributes<HTMLInputElement> {
  /**
   * FileSelect name. Has to be unique on the page. It sets also file select id.
   */
  name: string
  /**
   * When included it shows given error message and changes input border colour to red.
   */
  error?: string
  /**
   * A hint or description of the textarea
   */
  hint?: string
  /**
   * Disables input and uses readonly view.
   */
  readonly?: boolean
  /**
   * Allows multiple files selections.
   */
  multiple?: boolean
  accept?: string
  value?: string
  onChange?: ChangeEventHandler<HTMLInputElement>
  disabled?: boolean
  placeholder?: string
  label?: string
}

export const FileSelect = forwardRef<HTMLInputElement, FileSelectProps>(
  (
    {
      label,
      name,
      disabled,
      error,
      readonly,
      multiple,
      hint,
      onChange,
      accept,
      ...rest
    },
    inputRef,
  ) => {
    return (
      <>
        {label && (
          <label htmlFor={name} className="form-label">
            {label}
          </label>
        )}

        <input
          className={classnames({
            'form-control': !readonly,
            'form-control-readonly': readonly,
            'is-invalid': error,
          })}
          multiple={multiple}
          onChange={onChange}
          type="file"
          id={name}
          accept={accept}
          disabled={disabled}
          ref={inputRef}
          {...rest}
        />

        {error && <div className="invalid-feedback">{error}</div>}
        {hint && <div className="form-text">{hint}</div>}
      </>
    )
  },
)

FileSelect.displayName = 'InputFileSelect'

export default memo(FileSelect)
